import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Timeline, TimelineLite} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TombOfAkhenatenGameConfig} from "../../TombOfAkhenatenGameConfig";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {TOAGameEvent} from "../../events/TOAGameEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";

export class TOASymbolIdleAnimController implements GameRoundPresentation {
    private readonly _hasSymbolIdle: boolean = false;

    /**
     * @constructs
     */
    constructor() {
        this._hasSymbolIdle = (TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.idle !== undefined);
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: SpinParsedGameData): Timeline | null {
        if ((data.betWins && data.betWins.length > 0)) {
            return null;
        }

        if (!this._hasSymbolIdle) {
            return null;
        }

        const tl: TimelineLite = new TimelineLite(),
            startDelay: number = MathHelper.randomIntInRange(1, 5),
            symbol: StateReelSymbol | null = this.getRandomSym();
        symbol && tl.add(this.changeState.bind(this, this.getRandomSym()!), startDelay);

        //This function is called every time this tl is complete. So if does not have a duration it will trigger super ofter causing massive slowdown. Therefore you cant return a tl with only function calls. because it will be complete very quickly thus repeating the process super fast.
        if (tl.duration() > 0) {
            return tl;
        }
        return null;
    }

    private getRandomSym(): StateReelSymbol | null {
        const rnd: number = MathHelper.randomIntInRange(0, 24);
        const symbol = Reels.getSymbol(rnd, 0);
        if (rnd % 5 < 2) {
            return this.getRandomSym();
        }
        return symbol;
    }

    /**
     * @description Method in which the actual call is happening.
     * @param symbol
     */
    private changeState(symbol: StateReelSymbol): void {
        if(symbol?.symName === "S"){
            EventHandler.dispatchEvent( new GameEvent(TOAGameEvent.PLAY_BONUS_IDLE, symbol.reelId));
            return;
        }
        TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.idle && symbol.changeState({
            state: TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.idle,
            fadeInDuration: 0.2
        });
    }
}